"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Password = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _yup = require("@hookform/resolvers/yup");
var _reactHookForm = require("react-hook-form");
var yup = _interopRequireWildcard(require("yup"));
var _ui = require("../../ui");
var _validations = require("../../../validations");
var _fields = require("../../fields");
var _hooks = require("../../../hooks");
var _TermsFields = require("./TermsFields");
var _excluded = ["onSubmit", "withTerms"];
var _templateObject;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var schema = yup.object().shape({
  password: (0, _validations.passwordValidation)().required(),
  confirmPassword: (0, _validations.confirmationValidation)({
    toField: 'password',
    toFieldLabel: 'Password'
  }),
  terms: yup.boolean().when('$withTerms', {
    is: true,
    then: yup.boolean().oneOf([true]).required()
  }),
  policy: yup.boolean().when('$withTerms', {
    is: true,
    then: yup.boolean().oneOf([true]).required()
  })
}).required();
var PasswordStrength = (0, _styledComponents.default)(_ui.PasswordStrength)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 33px;\n"])));
var Password = function Password(_ref) {
  var onSubmit = _ref.onSubmit,
    withTerms = _ref.withTerms,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  var _useToggle = (0, _hooks.useToggle)(true),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    passwordHidden = _useToggle2[0],
    togglePasswordHidden = _useToggle2[1];
  var _useToggle3 = (0, _hooks.useToggle)(true),
    _useToggle4 = _slicedToArray(_useToggle3, 2),
    confirmPasswordHidden = _useToggle4[0],
    toggleConfirmPasswordHidden = _useToggle4[1];
  var _useForm = (0, _reactHookForm.useForm)({
      resolver: (0, _yup.yupResolver)(schema),
      context: {
        withTerms: withTerms
      }
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control,
    watch = _useForm.watch;
  var passwordValue = watch('password', '');
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, _extends({}, props, {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('password')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.PasswordInputGroupAddon, {
    addonType: "append",
    passwordHidden: passwordHidden,
    togglePasswordHidden: togglePasswordHidden
  }), /*#__PURE__*/_react.default.createElement(_fields.PasswordInputField, {
    control: control,
    inputProps: {
      passwordHidden: passwordHidden,
      placeholder: t('password'),
      name: 'password'
    }
  }))), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('confirmPassword')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.PasswordInputGroupAddon, {
    addonType: "append",
    passwordHidden: confirmPasswordHidden,
    togglePasswordHidden: toggleConfirmPasswordHidden
  }), /*#__PURE__*/_react.default.createElement(_fields.PasswordInputField, {
    control: control,
    inputProps: {
      passwordHidden: confirmPasswordHidden,
      placeholder: t('confirmPassword'),
      name: 'confirmPassword'
    }
  }))), /*#__PURE__*/_react.default.createElement(PasswordStrength, {
    password: passwordValue
  }), withTerms && /*#__PURE__*/_react.default.createElement(_TermsFields.TermsFields, {
    control: control
  }), props.children);
};
exports.Password = Password;